import { EditorPanelItem, ElementsPanelConfig } from '@editor/interfaces/editor'
import { InspectionArea } from '@editor/interfaces/inspection'

import usePlaneDetection from './panelHooks/usePlaneDetection'
import usePolyline from './panelHooks/usePolyline'
import useVolumeDetection from './panelHooks/useVolumeEstimation'

const useElementsPanel = (): ElementsPanelConfig => {
  // make sure this respects order set in editor/tools/setup.ts
  const allPanels = [useVolumeDetection(), usePolyline(), usePlaneDetection()]

  return {
    // run through all panel hooks and collect items
    getPanelItems: (parent?: EditorPanelItem['item'], area?: InspectionArea): EditorPanelItem[] =>
      allPanels.flatMap((panel) => (panel.getPanelItems ? panel.getPanelItems(parent, area) : [])),
  }
}

export default useElementsPanel
